module.exports = __webpack_public_path__ + "static/img/sanwei1.123d9aa5.png";